import angular from 'angular';
import { envRibbon } from './env-ribbon/env-ribbon.component.js';

(function() {
    'use strict';

    angular.module('app.widgets', []);

    angular.module('app.widgets').component('envRibbon', envRibbon);
})();
